import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=97e1fc5e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=97e1fc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e1fc5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e1fc5e')) {
      api.createRecord('97e1fc5e', component.options)
    } else {
      api.reload('97e1fc5e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=97e1fc5e&scoped=true&", function () {
      api.rerender('97e1fc5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2259AD7csNT6b/JS/comp/PopupDialog.vue"
export default component.exports